import React from 'react';
import renderHTML from 'react-render-html';
import './popup-header.css';

const PopupHeader = (props) => {
  const { PopTitle, PopupText, textCenter } = props;
  return (
    <div className="row popup-detail">
      <div className="col-12 popup-heading">
        <h2 className="text-center">{PopTitle}</h2>
      </div>
      {PopupText && (
        <div className={(textCenter) ? 'col-12 popup-description text-center' : 'col-12 popup-description'}>
          <span>{renderHTML(PopupText)}</span>
        </div>)}
    </div>

  );
};

export default PopupHeader;
